export default function MySQL_LEFT() {
  return (
    <div>
      <h2>MySQL_LEFT</h2>    </div>
  );
}